import { NgClass, NgStyle } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { IMarket, IOutcome, ISportEvent } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { BetslipService } from '../../../betslip/services/betslip/betslip.service';
import { ISRMSelectedQuestionAndAnswer } from '../../../core/models/srm.model';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { FracToDecService } from '../../../core/services/fracToDec/frac-to-dec.service';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { GtmTrackingService } from '../../../core/services/gtmTracking/gtm-tracking.service';
import { HandleLiveServeUpdatesService } from '../../../core/services/handleLiveServeUpdates/handle-live-serve-updates.service';
import { LocaleService } from '../../../core/services/locale/locale.service';
import { RaceOutcomeDetailsService } from '../../../core/services/raceOutcomeDetails/race-outcome-details.service';
import { horseracingConfig } from '../../../core/services/racing/config/horseracing.config';
import { RACING_CONFIG } from '../../../core/services/sport/config/racing.constant';
import { SessionStorageService } from '../../../core/services/storage/session-storage.service';
import { StorageService } from '../../../core/services/storage/storage.service';
import { UserService } from '../../../core/services/user/user.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { SharedModule } from '../../../shared/shared.module';
import { PriceOddsButtonSRMComponent } from '../priceOddsButtonSrm/price-odds-button-srm.component';

@Component({
    selector: 'srm-main',
    imports: [NgClass, NgStyle, SharedModule, PriceOddsButtonSRMComponent],
    templateUrl: './srm-main.component.html',
    styleUrl: './srm-main.component.scss',
})
export class SrmMainComponent implements OnInit, OnDestroy {
    @Input() eventEntity: ISportEvent;
    srmEventEntitymarkets: IMarket[];
    @Input() preEventMarkets: IMarket[];
    @Input() sortBy: string;
    @Input() expandedSummary: boolean[][];
    @Input() isNotAntepostOrSpecials: boolean;
    @Input() isSpOnly: boolean;
    @Input() sortOptionsEnabled: boolean;
    @Output() readonly toggleShowOptionsGATrackingFn = new EventEmitter();
    srmBtnCTA: string = this.localeService.getString('racing.srmCTA');
    selectedQbOutcomes = new Set<IOutcome>();
    getSilkStyle: Function;
    marketData: IMarket;
    eventStartDisableFlag: boolean;
    channels: string[] | any = [];
    isInfoHidden: { info: boolean };
    winOrEWLabel: string = this.localeService.getString('sb.winOrEachWay');
    winOrEWTemplateMarketName: string = RACING_CONFIG.WIN_OR_EW_TEMPLATE_MARKET_NAME;
    selectedQuestionAndAnswers: ISRMSelectedQuestionAndAnswer[] = [];
    srmSelectionData = {};
    srmOdds: string;
    scrollPosition: number;
    srmSelectedChannels: string[] | any = [];
    isGenericSilk: Function;
    constructor(
        private storageService: StorageService,
        private liveServeHandleUpdatesService: HandleLiveServeUpdatesService,
        protected raceOutcomeData: RaceOutcomeDetailsService,
        protected localeService: LocaleService,
        protected gtmService: GtmService,
        protected pubsub: PubSubService,
        protected gtmTrackingService: GtmTrackingService,
        private windowRef: WindowRefService,
        private userService: UserService,
        private fracToDecService: FracToDecService,
        protected sessionStorage: SessionStorageService,
        private betslipService: BetslipService,
    ) {
        this.getSilkStyle = this.raceOutcomeData.getSilkStyle;

        /**
         * Check generic silk needed
         * @param {Object} event
         * @param {Object} outcome
         * @returns {Boolean} true or false
         */
        this.isGenericSilk = this.raceOutcomeData.isGenericSilk;
    }

    getDefaultSilk(eventEntity: ISportEvent, outcomeEntity: IOutcome): boolean {
        return !outcomeEntity.racingFormOutcome && eventEntity.sportId === horseracingConfig!.config!.request!.categoryId!;
    }

    ngOnInit(): void {
        this.getSortedSRMmarkets();
        this.getPreviousSelections();
        this.channels.push(this!.eventEntity!.liveServChannels!.split(',')![0]!);
        this.liveServeHandleUpdatesService.subscribe(this.channels, this.updateEvent.bind(this));

        this.pubsub.subscribe('srm-main', this.pubsub.API.SRM_REMOVE_SELECTION, () => {
            this.pubsub.publish(this.pubsub.API.TOGGLE_SRM_BET, null);
            this.windowRef.nativeWindow.scrollTo(0, this.scrollPosition);
            this!.eventEntity!.markets!.forEach((market: IMarket) => {
                market.outcomes.forEach((outome) => {
                    outome.isSelected = false;
                });
            });
            this.selectedQuestionAndAnswers = [];
            this.srmSelectedChannels = [];
            this.selectedQbOutcomes.clear();
            this.storageService.remove('srmSelections');
            this.srmBtnCTA = this.localeService.getString('racing.srmCTA');
        });

        this.pubsub.subscribe('srm-main', this.pubsub.API.SET_ODDS_FORMAT, () => this.changeOddsandButtonCTA(this.selectedQbOutcomes));
    }

    ngOnDestroy(): void {
        this.liveServeHandleUpdatesService.unsubscribe(this.channels);
    }

    /**
     * function that fetches only SRM Markets based on disp Sort order
     * @return void
     */
    getSortedSRMmarkets(): void {
        this.srmEventEntitymarkets = this!
            .eventEntity!.sortedMarkets!.filter((market) => market.templateMarketName === RACING_CONFIG.SRM_TEMPLATE_MARKET_NAME)
            .sort(this.getComparatorByProperty('displayOrder') as any);
    }

    /**
     * returns function that compares items by corresponding property values
     * @param {string} propertyName
     * @return Function
     */
    private getComparatorByProperty(propertyName: string): Function {
        return (a: any, b: any) => {
            return a[propertyName] === b[propertyName] ? 0 : a[propertyName] < b[propertyName] ? -1 : 1;
        };
    }

    /**
     * Disabled the selection when event is live
     * @param {payload; type; id }liveUpdate
     */
    updateEvent(liveUpdate: { payload: any; type: any; id: any }): void {
        this.eventStartDisableFlag = liveUpdate.type === 'sEVENT' && liveUpdate.payload.started == 'Y' ? true : false;
    }

    /**
     * Setting the Selections made for each market(each selected outcome)
     * @param {IMarket} market
     * @param {number} ansIdx
     * @return void
     */
    selectAnswers(market: IMarket, ansIdx: number, marketIndex: number): void {
        market?.outcomes.forEach((outcome, index: string | number) => {
            if (index == ansIdx) {
                outcome.isSelected = !outcome.isSelected;
                outcome.marketName = market.name;
                outcome.marketDisplayOrder = marketIndex;
                outcome.marketliveServChannels = market.liveServChannels;
                if (outcome.isSelected) {
                    this.selectedQbOutcomes.add(outcome);
                } else {
                    this.selectedQbOutcomes.delete(outcome);
                }
            } else if (outcome.isSelected) {
                outcome.isSelected = !outcome.isSelected;
                this.selectedQbOutcomes.delete(outcome);
            }
        });
        this.setSelectionsInStorage(this.eventEntity, this.selectedQbOutcomes);
        this.changeOddsandButtonCTA(this.selectedQbOutcomes);
    }

    /**
     * Setting price odds based on selections and deselections(each selected outcome)
     * @param {Set<IOutcome>}selectedQbOutcomes
     * @return void
     */
    changeOddsandButtonCTA(selectedQbOutcomes: Set<IOutcome>): void {
        const outcomePrices = [];
        if (selectedQbOutcomes.size >= 2) {
            for (let val of selectedQbOutcomes) {
                outcomePrices.push({ price: val?.prices[0] });
            }
            const potentialReturns = this.getFormattedPrice(this.betslipService.getMultiplePotentialPayout({ outcomes: outcomePrices }));
            this.srmOdds = this.fracToDecService.getAccumulatorPrice(potentialReturns);
            this.srmBtnCTA = `${this.localeService.getString('racing.addSrmCTA')}${this.srmOdds}`;
        } else {
            this.srmBtnCTA = this.localeService.getString('racing.srmCTA');
        }
    }

    /**
     * Make price format according to User settings
     * @returns {String}
     */
    private getFormattedPrice(potentialPayout: any): string {
        if (this.userService && this.userService.oddsFormat === 'frac') {
            return this.fracToDecService.decToFrac(potentialPayout, true);
        }
        return this.fracToDecService.getNumberWith2Decimals(potentialPayout);
    }

    /**
     * Saving selection on storage to retain on refresh or navigations
     * @param {ISportEvent} event
     * @param {IOutcome} outcomes
     * @return void
     */
    setSelectionsInStorage(event: ISportEvent, outcomes: Set<IOutcome>): void {
        const storageObj = {
            eventId: event.id,
            selectedOutcomes: [...outcomes].map((outcome) => outcome.id),
        };
        this.storageService.set('srmSelections', storageObj);
    }

    /**
     * Fetch selection from storage to retain on refresh or navigations
     * @return void
     */
    getPreviousSelections(): void {
        const storedEventObj = this.storageService.get('srmSelections');
        if (storedEventObj && storedEventObj.eventId == this.eventEntity.id) {
            this.srmEventEntitymarkets.forEach((market, index) => {
                market.outcomes?.forEach((outcome) => {
                    if (storedEventObj.selectedOutcomes.includes(outcome.id)) {
                        outcome.isSelected = true;
                        outcome.marketName = market.name;
                        outcome.marketDisplayOrder = index;
                        outcome.marketliveServChannels = market.liveServChannels;
                        this.selectedQbOutcomes.add(outcome);
                    }
                });
            });
            this.changeOddsandButtonCTA(this.selectedQbOutcomes);
            if (this.sessionStorage.get('isSRMBet')) {
                this.showSRMSelectionsInQuickBet();
            }
        }
    }

    /**
     * Method to convert Outcome name to Title Case
     * @param {string} outcomeName
     * @return {string} name
     */
    getOutcomeName(outcomeName: string): string {
        return outcomeName
            .split(' ')
            .map((name) => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
            .join(',')
            .replaceAll(',', ' ');
    }

    /**
     * Check if sort options are showns
     * @param {boolean} isEW
     * @return {boolean}
     */
    sortOptionsEnabledFn(isEW: boolean): boolean {
        const selectedMarket = _.find(this!.eventEntity!.sortedMarkets!, (sortedMarket) => sortedMarket.name === this.winOrEWLabel);

        const isLP = selectedMarket && selectedMarket.isLpAvailable;

        return !!(
            isEW &&
            this.sortOptionsEnabled &&
            (!selectedMarket || (isLP && _.some(selectedMarket.outcomes, (o: IOutcome) => o.prices && o.prices.length > 0)))
        );
    }

    /**
     * Updates GTMservice
     * @param showOption:  option
     */
    public toggleShowOptionsGATrackingFunc(showOption: boolean): void {
        this.toggleShowOptionsGATrackingFn.emit(showOption);
    }

    /**
     * Toggle show options
     * param {array} summary of expanded and collapsed areas
     * param {number} market index.
     * param {showOption} boolean
     * @return void
     */
    toggleShowOptionsFunc(expandedSummary: Array<Array<boolean>>, mIndex: number, showOption: boolean): void {
        for (let i = 0; i < expandedSummary[mIndex].length; i++) {
            expandedSummary[mIndex][i] = showOption;
        }
    }

    /**
     * Click on Horse Block.
     * Toggle Horse Information Area.
     * param {array} summary of expanded and collapsed areas.
     * param {number} market index.
     * param {number} outcome index.
     * @return void
     */
    onExpandSection(expandedSummary: Array<Array<boolean>>, mIndex: number, oIndex: number): void {
        expandedSummary[mIndex][oIndex] = !expandedSummary[mIndex][oIndex];
        const hideInfoChecker: boolean = expandedSummary[mIndex].every((v: boolean) => v === false);
        this.isInfoHidden = { info: !hideInfoChecker };
        const gtmData = {
            event: 'trackEvent',
            eventAction: 'race card',
            eventCategory: 'horse racing',
            eventLabel: expandedSummary[mIndex][oIndex] ? 'show more' : 'show less',
            categoryID: this.eventEntity.categoryId,
            typeID: this.eventEntity.typeId,
            eventID: this.eventEntity.id,
        };
        this.gtmService.push(gtmData.event, gtmData);
    }

    /**
     * Shows SRM selection details in QB on click of Same race multi button
     * @return void
     */
    showSRMSelectionsInQuickBet() {
        this.scrollPosition = this.windowRef.nativeWindow.scrollY;
        this.srmSelectedChannels.push(this!.eventEntity!.liveServChannels!.split(',')![0]!);
        this.selectedQbOutcomes.forEach((selectedOutcome) => {
            this.selectedQuestionAndAnswers.push({
                question: selectedOutcome['marketName'] || '',
                answer: selectedOutcome['name'],
                marketDisplayOrder: selectedOutcome['marketDisplayOrder'] || 0,
                selectionId: selectedOutcome['id'],
            });
            this.srmSelectedChannels.push(selectedOutcome!.marketliveServChannels!.split(',')[0]);
            this.srmSelectedChannels.push(selectedOutcome!.liveServChannels!.split(',')![0]!);
        });
        this.selectedQuestionAndAnswers.sort((a, b) => a.marketDisplayOrder - b.marketDisplayOrder);
        this.buildSRMSelectionDetails();
        this.pubsub.publish(this.pubsub.API.TOGGLE_SRM_BET, {
            selection: this.srmSelectionData,
            selectedQuestionAndAnswers: this.selectedQuestionAndAnswers,
            srmSelectedChannels: this.srmSelectedChannels,
            srmOdds: this.srmOdds,
            selectionEventLocalTime: this.eventEntity.localTime,
        });
        this.windowRef.nativeWindow.scrollTo(0, 0);
    }

    /**
     * Builds SRM selection details which is required in QB to show
     * @return void
     */
    buildSRMSelectionDetails() {
        let { srmNum, srmDen } = this.getSRMPriceInFraction();

        const tracking = this.gtmTrackingService.detectTracking('gtmModule', 'segment', this.eventEntity, this!.eventEntity!.markets![0]!);
        const GTMObject = {
            categoryID: this.eventEntity && String(this.eventEntity.categoryId),
            typeID: this.eventEntity && String(this.eventEntity.typeId),
            eventID: this.eventEntity && String(this.eventEntity.id),
        };
        (GTMObject as any)['tracking'] = tracking!;
        this.srmSelectionData = {
            event: this.eventEntity,
            freebetList: [],
            request: {
                isSRMBet: true,
                selectionType: 'simple',
                fanzoneTeamId: '',
                oddsBoost: false,
                outcomeIds: [],
            },
            selectionPrice: {
                priceType: 'LP',
                priceNum: srmNum,
                priceDen: srmDen,
                priceDec: this.fracToDecService.fracToDec(srmNum!, srmDen),
            },
            selectionInfo: {
                eventName: this.eventEntity.name,
                newOdds: this.srmOdds,
                potentialOdds: '0.00',
            },
            GTMObject,
            marketStatusCode: 'A',
            outcomeStatusCode: 'A',
        };
    }

    /**
     * Converts price from decimal value to fraction
     * @return {srmNum: number|string, srmDen:number|string}
     */
    getSRMPriceInFraction() {
        let srmNum: any, srmDen: any;

        if (this.srmOdds) {
            if (this.srmOdds.includes('/')) {
                [srmNum, srmDen] = this.srmOdds.split('/');
                if (srmNum.includes('.')) {
                    srmNum = (srmNum * 100).toFixed(0);
                    srmDen *= 100;
                }
            } else {
                srmNum = ((+this.srmOdds - 1) * 100).toFixed(0);
                srmDen = 100;
            }
        }

        return { srmNum, srmDen };
    }
}
